import styled from "styled-components";

export const RetailMatchBrandCardWrapper = styled.div`
  width: 100%;
  height: 175px;
  text-align: center;
  margin-bottom: 12px;
  position: relative;
`;
